import React, { PropsWithChildren, useCallback, useEffect } from 'react';
import BSModal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Draggable from 'react-draggable';

import { modalClosed } from '../../Store/Modal/action';
import ModalDialog from 'react-bootstrap/ModalDialog';

import { useDispatch } from 'react-redux';
import useGetModal from '../../Hook/UseGetModal';

const DraggableModalDialog: React.FC = (props: PropsWithChildren<any>) => (
    <Draggable handle=".modal-header">
        <ModalDialog>{props.children}</ModalDialog>
    </Draggable>
);

const Modal: React.FC = () => {
    const dispatch = useDispatch();
    const { button, content, title, className } = useGetModal();
    const closeModal = useCallback(() => dispatch(modalClosed()), [dispatch]);

    useEffect(() => {
        document.body.classList.toggle('draggable-modal', content !== null);
    }, [content]);

    return (
        <BSModal
            dialogAs={DraggableModalDialog}
            show={content !== null}
            backdrop="static"
            enforceFocus={false}
            animation={false}
            onHide={closeModal}
            className={className}
        >
            <BSModal.Header closeButton placeholder="">
                <BSModal.Title>{title}</BSModal.Title>
            </BSModal.Header>
            <BSModal.Body>{content}</BSModal.Body>
            <BSModal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Sluiten
                </Button>
                {button}
            </BSModal.Footer>
        </BSModal>
    );
};

export default Modal;
